import { useFetchPatient } from "@/infra/apis/patients/useFetchPatient";
import { useFetchActiveTreatment } from "@/infra/apis/treatments/useFetchActiveTreatment";

export const useFetchPatientAndActiveTreatment = () => {
  const { data: patient, isLoading: isPatientLoading } = useFetchPatient();
  const { data: activeTreatment, isLoading: isTreatmentLoading } = useFetchActiveTreatment();

  return {
    patient,
    activeTreatment,
    isLoading: isPatientLoading || isTreatmentLoading,
  };
};
